/**
 * One row of the rate dropdown: the service under the carrier, with the price out to the right.
 * Built as the option's whole label, because the generic prints a description under whatever the
 * label is and the design puts the price beside it.
 */
import Currency from "../../../../../../../../components/currency/currency";
import FontBody1 from "../../../../../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../../components/fonts/font-props";
import IconInfo from "../../../../../../../../components/icons/icon-info/icon-info";
import Icon from "../../../../../../../../components/icons/icon/icon";
import { Tooltip } from "../../../../../../../../components/tooltip/tooltip";
import { IPortalDynamicShippingOptionDto } from "../../../../../rma-types";
import "./shipping-rate-option.scss";

/** Some carriers only settle the fee once the label is printed, so a rate may arrive without one. */
const PENDING_FEE_TOOLTIP = "The Fee will be set only after label printing.";

export const hasPrice = (rate: IPortalDynamicShippingOptionDto): boolean =>
    !!rate.currency_code && Number.isFinite(rate.cost);

interface IProps {
    rate: IPortalDynamicShippingOptionDto;
    isCheapest: boolean;
}

const ShippingRateOption: React.FC<IProps> = ({ rate, isCheapest }) => (
    <span className="resolve-label-error-shipping-rate-option">
        <span className="resolve-label-error-shipping-rate-option-service">
            <FontBody1 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>
                {rate.name}
            </FontBody1>
            <FontBody2 color={FONT_COLOR.NEUTRAL3}>{rate.description}</FontBody2>
        </span>

        <span className="resolve-label-error-shipping-rate-option-price">
            {isCheapest && (
                <FontBody2 color={FONT_COLOR.NEUTRAL3}>(Cheapest)</FontBody2>
            )}

            {hasPrice(rate)
                ? (
                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>
                        <Currency currencyCode={rate.currency_code} amount={rate.cost} useNative />
                    </FontBody1>
                )
                : (
                    <Tooltip content={
                        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>{PENDING_FEE_TOOLTIP}</FontBody2>
                    }>
                        <Icon Component={IconInfo} />
                    </Tooltip>
                )}
        </span>
    </span>
);

export default ShippingRateOption;
